import React from 'react';

const currencyMaps = {
    1: 'kgs',
    2: 'rub',
    3: 'tjs',
    4: 'kzt',
    5: 'usd',
    6: 'eur'
}

class AuthedSidebarWidgetContainer extends React.Component {
    _timeoutId = null;

    componentDidMount() {
        const _bt2 = _bt2 || [];

        _bt2.push(['server', 'https://widget02.betgames.tv']);
        _bt2.push(['partner', 'fairplay_kz']);
        _bt2.push(['token', this.props.betGames.get('token')]);
        _bt2.push(['language', 'ru']);
        _bt2.push(['currency', currencyMaps[this.props.user.get('resourceId')]]);
        _bt2.push(['iframe_url', 'https://www.fp.kz/betgames']);

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = `https://widget02.betgames.tv/js/betgames-widget.js?ts=${Date.now()}'`;
        const parent = document.getElementById('BetGamesWidget_div_iframe');
        parent.appendChild(script);

        this._timeoutId = window.setTimeout(() => {
            window.BetGamesWidget.frame(_bt2);
        }, 3000);
    }

    componentWillUnmount() {
        if (this._timeoutId !== null) {
            window.clearTimeout(this._timeoutId);
        }
    }

    render() {
        return (
            <div id='BetGamesWidget_div_iframe' />
        )
    }
}

export default AuthedSidebarWidgetContainer;


// WEBPACK FOOTER //
// ./js/sport-betting/components/betgames/AuthedSidebarWidgetContainer.jsx